<template>
    <consent :config="config" :key="config.storeField"></consent>
</template>
<script>
    import Consent from '../template/Consent';
    import ConsentText from '../../assets/consents/patientTreatmentContract.txt'

    export default {
        components: {Consent},
        data: function () {
            return {
                config: {
                    title: 'Patient Treatment Contract',
                    consentText: ConsentText,
                    checkboxText: 'I agree to the Patient Treatment Contract',
                    storeField: 'accepted_consent_patient_treatment_contract',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function () {
                      await this.$router.push('/reg/consentSpecimenCollection')
                    }.bind(this)
                }
            }
        }
    }
</script>
